export default {
      id: "slider_left-usage",
      viewBox: "0 0 13 21",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#slider_left",
      toString: function () {
        return this.url;
      }
    }